import React from 'react'


import { Box, Typography, Stack, Divider } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import JobDescription from '../job-details/job-description';
import moment from 'moment';
import Grid from "@mui/material/Grid2"; // Updated to Grid2

export default function Informations({ jobData }) {
  return (
    <Stack direction="row" sx={{
        gap: {xs: 2, md: "60px"},
        flexDirection: {
            xs: 'column',
            md: 'row'
        },
    }}>
        <Stack minWidth="20%" alignItems="flex-end" sx={{
            alignItems: {
                xs: 'flex-start',
                md: 'flex-end'
            },
            display: {
                xs: 'none',
                md: 'flex'
            },
        }}>
            <Typography fontSize="24px" fontWeight={600}>Om tjänsten</Typography>
        </Stack>

        <Grid  spacing={8} flexGrow={1}>
            {/* Left Side (Main Content) */}
            <Grid  size={{xs: 12, md: 7}}>
                <Box>
                <Stack alignItems='start' justifyContent='space-between' sx={{
                        flexDirection: {
                            xs: 'column-reverse',
                            md: 'row'
                        },
                        marginBottom: { xs: 2, md: 0},
                        gap: {md: 2, xs: 1}
                }}>
                    <Stack>
                        <Typography variant="h4">
                            {jobData?.jobDetails?.title}
                        </Typography>
                    </Stack>

                    <Stack direction='row' gap={1} alignItems='center'>
                        <CalendarTodayIcon color='black' fontSize='small' sx={{
                            display: {xs: 'none', md: 'block'}
                        }} />

                        <Typography sx={{
                            fontSize: { xs: '12px', md: '16px'}
                        }}>{moment(jobData?.jobDetails?.createdAt).format('MMM D, YYYY')}</Typography>
                    </Stack>

                </Stack>

                <Divider sx={{
                    display: {xs: 'block', md: 'none'},
                    marginBottom: 2
                }} />

                <Stack direction="row" flexWrap="wrap" sx={{
                    gap: { xs: '10px', md: 4},
                    margin: { xs: '10px 0 20px 0', md: '10px 0 20px 0'}
                }}>
                    {jobData?.jobDetails?.location &&

                        <>
                            <Stack direction="row" gap={1} alignItems="center">
                                <img src="/assets/icons/location.svg" alt="location icon" />
                                <Typography fontWeight={600}>{jobData.jobDetails.location}</Typography>
                            </Stack>

                            {/* <Divider orientation="vertical"  flexItem /> */}
                        </>
                    }



                    {jobData?.jobDetails?.salary &&
                    
                    <>
                        <Stack direction="row" gap={1} alignItems="center">
                            <img src="/assets/icons/money.svg" alt="money icon" />
                            {jobData?.jobDetails?.salaryRange ? 
                                <Typography fontWeight={600}>
                                    {jobData?.jobDetails?.salary.from} {jobData?.jobDetails?.currency}-{jobData?.jobDetails?.salary.to} {jobData?.jobDetails?.currency} / {jobData?.jobDetails?.timeUnit}
                                </Typography> :

                                <Typography fontWeight={600}>
                                    {jobData?.jobDetails?.salary.static} {jobData?.jobDetails?.currency} / {jobData?.jobDetails?.timeUnit}
                                </Typography>
                            }

                        </Stack>
                        
                    </>

                    }

                    {jobData?.jobDetails?.typeOfContract &&
                    <Stack direction="row" gap={1} alignItems="center">
                        <img src="/assets/icons/bag.svg" alt="bag icon" />
                        <Typography fontWeight={600}>{jobData?.jobDetails?.typeOfContract}</Typography>
                    </Stack>
                    }
                </Stack>

                <Divider sx={{
                    display: {xs: 'block', md: 'none'},
                    marginBottom: 2
                }} />

                {/* Job decsription */}
                <JobDescription description={jobData?.jobDetails?.description} />

                </Box>
            </Grid>
        </Grid>
    </Stack>
  )
}
